import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from "react-redux";
import { Sheet, Button, Stack, Typography } from '@mui/joy';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import {Material, Notice} from 'domain';
import FileUploader from 'components/core/FileUploader';
import appActions from "actions/appActions";

const MAX_SIZE = 5242880; // 5mb

const AttachmentForm = ({ material, onChange }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const fileName = material?.data?.name ?? material?.attachment?.name();

    const handleUpload = (parseFile, fileMetadata) => {
        setIsLoading(false);
        onChange('attachment', parseFile);
        onChange('data', fileMetadata);
    };

    const handleUploadClick = () => {
        setIsLoading(true);
    };

    const handleError = (error) => {
        dispatch(appActions.addNotice(new Notice({title: error, type: Notice.TYPE_ERROR})))
        setIsLoading(false);
    }

    return (
        <Stack gap={2}>
            <Typography level="body-sm">
                    Share downloadable document with your students.
                    If you&apos;d rather your users view an image or PDF, use the &quot;Image&quot; or &quot;PDF&quot;
                    material type. There is a <strong>5mb size limit</strong> to files. For very large files, you may
                    want to use Dropbox or Google Drive and then use a &quot;Web URL&quot; material type to link to
                    that file.
            </Typography>
            <Sheet sx={{ p: 2, textAlign: "center" }} color="primary">
                {fileName && (
                    <Typography level="h5" mb={2}>
                        {fileName}
                    </Typography>
                )}
                <Button
                    variant="solid"
                    color="primary"
                    startDecorator={<CloudUploadIcon />}
                    loading={isLoading}
                    loadingPosition="start"
                    onClick={handleUploadClick}
                >
                    {material?.attachment ? 'Replace' : 'Upload'}
                </Button>
            </Sheet>
            <FileUploader
                open={isLoading}
                onUpload={handleUpload}
                onError={handleError}
                maxSize={MAX_SIZE}
            />
        </Stack>
    );
};

AttachmentForm.propTypes = {
    material: PropTypes.instanceOf(Material).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default AttachmentForm;
